import React, { Component } from 'react';
import BsySLoading from "../../BsySLoading";
import './index.css'

class BsyDashWebPage extends Component {
    constructor(props){
        super(props)
        this.state = {
            isLoading: true,
            webParameter: props.webParameter,
            webUrl: props.webUrl,
            webParameterList: {}
        }
    }

    componentDidMount() {
        if (this.props.getContext) {
            this.props.getContext(this);
        }
    }

    reload = () => {
        this.loadData(!0)
    }

    loadWidget = (n, d, s) => {
        this.loadData(n, d, s);
    }

    loadData = () =>{
        React.axios('/data/getCurrentUserInfo',{appId:this.props.appId}).then((res)=>{
            this.setState({webParameterList:res.data.data,isLoading:false})
        })
    }

    render() {
        const {isLoading, webParameterList, webUrl, webParameter} = this.state;
        let url = '';
        webParameter && webParameter.length> 0 && webParameter.map((res, key)=>{
            let sym = ''
            if(key !== 0){
                sym = '&'
            }
            switch (res) {
                case 'webpage_corp_id':
                    url += sym + 'webpage_corp_id=' + encodeURIComponent(webParameterList.corp_id ? webParameterList.corp_id : '');
                    break;
                case 'webpage_user_id':
                    url += sym + 'webpage_user_id=' + encodeURIComponent(webParameterList.user_id ? webParameterList.user_id : '');
                    break;
                case 'webpage_phone':
                    url += sym + 'webpage_phone=' + encodeURIComponent(webParameterList.mobile ? webParameterList.mobile : '');
                    break;
                case 'webpage_account':
                    url += sym + 'webpage_account=' + encodeURIComponent(webParameterList.account ? webParameterList.account : '');
                    break;
                case 'webpage_email':
                    url += sym + 'webpage_email=' + encodeURIComponent(webParameterList.email ? webParameterList.email : '');
                    break;
                case 'webpage_corp_user_id':
                    url += sym + 'webpage_corp_user_id=' + encodeURIComponent(webParameterList.uniqueid ? webParameterList.uniqueid : '');
                    break;
            }
        })
        if(webUrl){
            if (webUrl.indexOf('?') > -1) {
                let urlList = webUrl.split('?');
                url = urlList[0] + '?' + url + '&' + urlList[1]
            }else{
                url = webUrl + '?' + url
            }
        }
        return (
            <div className="BsyDashWebPage">
                {
                    isLoading ? <BsySLoading mode={'skeletonspin'} /> : ''
                }
                {
                    !isLoading && <iframe frameborder="0" width="100%" height="100%" src={url}></iframe>
                }
            </div>
        );
    }
}

export default BsyDashWebPage;
